define( [
	"./document"
], function( document ) {
	return document.documentElement;
} );



// WEBPACK FOOTER //
// ./~/jquery/src/var/documentElement.js